import FEATURES, { DEFAULT_FEATURES } from '@/toggles';
export const features = {
    namespaced: true,
    state: FEATURES,
    mutations: {
        set(state, features) {
            Object.keys((key) => {
                state[key] = features[key];
            });
        },
        enable(state, feature) {
            if (feature in state) {
                state[feature] = true;
            }
        },
        disable(state, feature) {
            if (feature in state) {
                state[feature] = false;
            }
        },
        reset(state) {
            Object.keys(DEFAULT_FEATURES).forEach((feat) => {
                state[feat] = DEFAULT_FEATURES[feat];
            });
        },
    },
};
